<template>
  <div style="background:#eee"> 

    <v-app v-if="selected_objects.length==0" class="ma-2" style="background:#eee">
      <v-sheet>
        <v-container id="dashboard" fluid tag="section">
          <center class="mt-12 pt-12">
            <v-icon class="mt-12" size="100" color="grey --darken-2">mdi-car-off</v-icon>
            <h3 class="pt-5">{{selected_objects.length==0? 'No Asset Selected': 'Multiple Asset Selected'}} </h3>
            <p class="title pt-5">Select a single asset to view the asset info</p>
          </center>
        </v-container>
      </v-sheet>
    </v-app> 

    <v-app
      id="ui"
      class="pa-1"
      style="background:#eee"
      fluid
      app
      tag="section"
     v-if="selected_objects.length>0"
    >
      <v-overlay
        :absolute="false"
        :opacity="0.45"
        :value="fetching_data"
        :z-index="3939938498494989"
      >
        <v-skeleton-loader
          :transition="'scale-transition'"
          height="94"
          width="350"
          type="list-item"
          class="loader"
        ></v-skeleton-loader>
      </v-overlay>
      
      <v-container id="dashboard" fluid tag="section">
        <v-toolbar
          dark
          v-bind:color="! selected_objects[0].engineon? 'grey lighten-1':'green lighten-1'"
        >
          <v-toolbar-title>
            <h3 class="font-weight-light">
              <span>
                <v-icon large>mdi-truck</v-icon>
              </span>
              {{ ' '+ selected_objects[0].name }}
            </h3>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <small>({{ !selected_objects[0].engineon? 'Engine Off':'Engine On' }})</small>
        </v-toolbar>
        <v-tabs color="orange" v-model="tabs">
          <br />
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#movements" @click="page=1">
            <v-icon>mdi-map-marker-path</v-icon>
            <small class="px-3">Movements</small>
          </v-tab>

          <v-tab href="#stops" @click="page=1">
            <v-icon>mdi-car-brake-parking</v-icon>
            <small class="px-3">Stops</small>
          </v-tab>

          <v-tab href="#alerts" @click="page=1">
            <v-icon>mdi-alert-remove-outline</v-icon>
            <small class="px-3">Alerts</small>
          </v-tab>

          <v-tab href="#map" @click="page=1">
            <v-icon>mdi-map</v-icon>
            <small class="px-3">View On Map</small>
          </v-tab> 

          <v-spacer></v-spacer>

          <v-tab>
            <small class="px-3">Date</small>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <br />
                <v-text-field
                  v-model="date"
                  label
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="date" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(date); available_data();">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-tab>
        </v-tabs>
 
      <div v-if="top_dash.length > 1">
        <v-row>
          <v-col cols="6" sm="4" lg="2" v-for="item in top_dash" :key="item.title">
            <v-card elevation="2" outlined shaped :color="item.color">
              <v-card-title class="display-2 grey--text font-weight-light">
                <small>{{item.title}}</small>
              </v-card-title>
              <v-card-text class="pt-2">{{item.value}}</v-card-text>
            </v-card>
          </v-col>
        </v-row> 
</div>

        
 
            <v-tabs-items v-model="tabs" v-if="!fetching_data" style="background: #eee"> 
            <v-tab-item :value="'movements'">
              <div v-if="!fetching_data && trip_data.drives.length==0">
          <br>
             <v-alert border="left" color="blue-grey accent-2" colored-border type="info"  elevation="2" > 
               <div class="display-1  font-weight-light">No vehicle movement records available.</div> 
               </v-alert>  
        </div>
              <v-alert v-for="(drive,i) in filterrable(trip_data.drives)" :key="i" border="left" :color="drive[8]>60?'red accent-4':'blue accent-4'" colored-border  elevation="0" > 
              <div><v-icon>mdi-map-marker-distance</v-icon> <span class="px-3 display-1 font-weight-light"> {{drive[15].from}} <b class="orange--text">-</b> {{drive[15].to}}</span>   </div> 
              <div class="body-1  font-weight-light py-2"><v-icon>mdi-clock-time-two-outline</v-icon> <i class="px-2"></i>{{drive[6]}}  <small class="px-4">({{drive[4]}} - {{drive[5]}})</small></div>
              <div class="body-1  font-weight-light py-1"><v-icon>mdi-road-variant</v-icon> <i class="px-2"></i>{{drive[7] +" km"}}</div>
              <div class="body-1  font-weight-light py-1"><v-icon>mdi-fuel</v-icon> <i class="px-2"></i>{{drive[10] +" ltr"}}</div>
              <div class="row py-1 ml-1">
                <div cols="10" class="body-1  font-weight-light"><v-icon>mdi-speedometer</v-icon> <i class="px-2"></i>{{drive[8] +" kph"}} <small class="px-4">(Top Speed)</small> <i class="px-2"></i>{{drive[9] +" kph"}} <small class="px-4">(Average trip Speed)</small></div>
                <div cols="2" class="body-1  font-weight-light"> <v-btn class="ml-10" :loading="fetching_trip" small outlined @click="fetch_drive(drive)"><small>View On Map</small></v-btn></div>
              </div>
              </v-alert> 
              <v-pagination v-model="page" v-if="trip_data.drives.length>page_size" :length="round(trip_data.drives.length/page_size)"></v-pagination>
            </v-tab-item>

            <v-tab-item :value="'stops'"> 
               <div v-if="!fetching_data &&   trip_data.stops.length==0">
                <v-alert border="left" color="blue-grey accent-2" colored-border type="info"  elevation="2" > 
                    <div class="display-1  font-weight-light">No vehicle movement records available.</div> 
                    </v-alert>  
              </div>

              <v-alert border="left" color="blue-grey accent-2"  v-for="(drive,i) in filterrable(trip_data.stops)" :key="i" colored-border  elevation="0" > 
              <div class="display-1  font-weight-light"><v-icon>mdi-google-maps</v-icon> <i class="px-2"></i>{{drive[13]}}</div> 
               <div class="row py-3 ml-0">
                <div cols="10" class="body-1  font-weight-light"><v-icon>mdi-clock-time-two-outline</v-icon> <i class="px-2"></i>{{drive[8]}}  <small class="px-4">({{drive[6]}} - {{drive[7]}})</small></div>
                <div cols="2" class="body-1  font-weight-light"> <v-btn class="ml-10" small outlined @click="showMap(drive,'stops')"><small>View On Map</small></v-btn></div>
              </div>
              </v-alert> 
              <v-pagination v-model="page" v-if="trip_data.stops.length>page_size" :length="round(trip_data.stops.length/page_size)"></v-pagination>
            </v-tab-item>

            <v-tab-item  :value="'alerts'">
               <div v-if="!fetching_data &&   trip_data.events.length==0">
                <v-alert border="left" color="blue-grey accent-2" colored-border type="info"  elevation="2" > 
                    <div class="display-1  font-weight-light">No vehicle movement records available.</div> 
                    </v-alert>  
              </div> 

              <v-alert v-for="(drive,i) in filterrable(trip_data.events)" :key="i" border="left" color="red accent-4" colored-border  elevation="0" >
                <div><v-icon>mdi-map-marker-distance</v-icon> <span class="px-3 display-1 font-weight-light"> {{drive[0]}} <b class="orange--text">-</b> {{drive[8]}}</span>   </div> 
              <div class="body-1  font-weight-light py-2"><v-icon>mdi-clock-time-two-outline</v-icon> <i class="px-2"></i>{{drive[1]}} </div>  
               <div class="row py-3 ml-0">
                <div cols="10" class="body-1  font-weight-light"><v-icon>mdi-speedometer</v-icon> <i class="px-2"></i>{{drive[6] +" kph"}}</div>
                <div cols="2" class="body-1  font-weight-light"> <v-btn class="ml-10" small outlined @click="showMap(drive,'alert')"><small>View On Map</small></v-btn></div>
              </div>
              </v-alert> 
              <v-pagination v-model="page" v-if="trip_data.events.length>page_size" :length="round(trip_data.events.length/page_size)"></v-pagination>
            </v-tab-item>

              <v-tab-item :value="'map'">
                <div style="min-height: 300px">
                    <Map :tracking_data="tracking_data" />
                </div> 
            </v-tab-item> 
          </v-tabs-items> 

        <div>  
        </div>
      </v-container>
 
    </v-app>
  </div>
</template>
 

<script>
import moment from "moment";
import { mapMutations, mapState } from "vuex";
import common from "../mixins/common"; 
import Map from "../account/Map"

export default {
  name: "Trips",
  mixins: [common ],
  components:{ Map },
  props: ['selection_type','selected_objects'],
  computed: {
    ...mapState(["notification", "session"])
  },
  data() {
    return {
      top_dash: [],
      m_notification: [],
      trip_data: {
        drives: [],
        events: [],
        stops: []
      },
      tracking_data: [{lat:1.1, lng: 1.1, speed: 200, engineon: true}],
      date: new Date().toISOString().substr(0, 10), 
      fetching_data: false,
      fetching_trip: false,
      page: 1, 
      page_size: 10,
      menu: false,
      modal: false,
      tabs: null, 
    };
  },
  created() {
    if (this.selected_objects.length > 0) this.available_data(); 
  },
  methods: {
    filterrable(array){
      var new_array = [];  
      for(var i = this.page_size * (this.page -1); i < this.page * this.page_size; i++ ){
        if(i>=array.length)
          break;
        new_array.push(array[i]); 
      } 
      return new_array;
    },
    round(data){
      return Math.ceil(data);
    },
 
    showMap(data,source){ 
      if(source=="stops"){
        this.tracking_data = [];
        this.tracking_data.push({lat: data[2],lng: data[3],speed: 0,engineon: false,current_loc: data[13],dt_tracker: data[8], plate_number: this.selected_objects[0].plate_number });
        this.tabs ="map";
      } else if(source == "alert"){  
        this.tracking_data = []; 
        this.tracking_data.push({lat: data[2],lng: data[3],speed: data[6],engineon: true,current_loc: data[8],dt_tracker: data[1] , plate_number: this.selected_objects[0].plate_number});
        this.tabs ="map"; 
      }
    },

    fetch_drive(trip){
      this.fetching_trip = true;
      this.tracking_data = [];  
      this.http_connect("/get_route", {
        token: this.check_token(),
        dtf: trip[4],
        dtt: trip[5],
        imei: this.selected_objects[0].imei
      }).then(res => {
        this.fetching_trip = false; 
        res.data.map(c=>{  
          this.tracking_data.push({lat: c[1],lng: c[2],speed: c[5],engineon: true,current_loc: c[7],dt_tracker: c[0] , plate_number: this.selected_objects[0].plate_number });
        });
        this.tabs = "map"
      });  
    },

    available_data() { 
      this.top_dash =[]; 
      this.fetching_data = true;
      this.http_connect("/vehicle_status", {
        token: this.check_token(),
        dtf: this.date +" 00:00:00",
        dtt: this.date + " 23:59:59",
        imei:  this.selected_objects[0].imei
      })
        .then(res => {
          if (res.status == 200) {  
            this.fetching_data = false;
            this.trip_data = res.data;
            this.top_dash =[];  
            this.top_dash.push({
              title: "Hours Moved",
              value: res.data.drives_duration,
              subtitle: "Time",
              color: "purple lighten-5"
            });
            this.top_dash.push({
              title: "Distance Covered",
              value: res.data.route_length.toLocaleString() + " km",
              subtitle: "KM",
              color: "blue lighten-5"
            });
            this.top_dash.push({
              title: "Fuel Consumed",
              value: res.data.fuel_consumption.toLocaleString() + " ltr",
              subtitle: "ltr",
              color: "lime lighten-5"
            });
            this.top_dash.push({
              title: "Average Speed",
              value: res.data.avg_speed + " kph",
              subtitle: "kph",
              color: "amber lighten-5"
            });
            this.top_dash.push({
              title: "Top Speed",
              value: res.data.top_speed + " kph",
              subtitle: "KPH",
              color: "deep-orange lighten-5"
            });
            this.top_dash.push({
              title: "Hours Parked",
              value: res.data.stops_duration,
              subtitle: "Time",
              color: "light-yellow accent-5"
            });
          }
        })
        .catch(err => {});
    }
  },
   computed: {
        objectsOnly: function(){
            var objs = [];
            this.objects.map(c=>{
                c.children.filter(e=> e.loc_valid=="1").map(d=> objs.push(d));
            }); 
            return objs;
        }
  },
  watch: { 
        selected_objects: {
            handler: function (val, oldVal) {    
              if(val.length>0 && oldVal.length>0){
                if(val[0].plate_number != oldVal[0].plate_number  ){
                   this.available_data();
                    this.tracking_data = [];
                    this.tabs = "movements"
                }
                 
              } 
            },
            deep: true
        },
    },  
};
</script>

<style scoped>
#dashboard,
template {
  background: #eee;
}
</style>
